module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AXDQbJ/tc-custom/FC-9781528957977.jpg?1685327561968?1709061458801",
      "alt": "This image is the cover for the book The Pretty Girls"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Pretty Girls\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It is 1860, and Hannah Morley and her widowed mother have fallen on hard times. They have moved from the country into cheap lodgings in Blackfriars Lane, Manchester, and become deeply concerned for the welfare of a child who lives next door. Meanwhile, Hannah finds work at the sprawling Bronton workhouse, which is undergoing many changes under the supervision of the master, John Gidley. She becomes acquainted with several of the workhouse guardians and with the unpleasant Miss Phipps. As Hannah and her mother become increasingly disturbed by the knowledge that all is far from well next door, she also suspects sinister goings-on at the workhouse. Could there possibly be a link with Blackfriars Lane?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hazel Aitken\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Hazel Aitken lives in Fife and has been publishing short stories, articles and poems for many years. She has three adult sons and four grandchildren, and enjoys trips to co Kildare, Ireland, where some of the family live. Involved in practical charity work, she also has a passion for social history, gardening and for the cats she has rescued.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0